import { gql } from '@apollo/client';

const TaskFields = gql`
  fragment TaskFields on Task {
    id
    title
    description
    descriptionHtml
    localTaskId
    projectId
    statusName
    dueAt
    createdAt
    updatedAt
  }
`;

export const fragments = {
  TaskFields
};
